import { closeModal } from '@/functions/function.js';
import $ from 'jquery'

export default {
    name: 'show-article',

    components: {
    },
    props: [],
    data () {
        return {
            save_loading: false,
            fields_attribut: ['libelle', 'type', 'occurence', 'action'] ,
            field_modification: [ 'ancien' , 'nouveau', 'date'],
            filter: "",
            perPage: 8,
            currentPage: 1,
            attributs: {},
            attribut: {
                'id': "",
                'libelle': "",
                'type_attribut_id': "",
                'occurence': [],
                'type': "",
            },
            occurence: [],
            val_occurence: "",

            occurences_to_delete: [],
            occurences_to_add: [],

            type_article_id: '',            // Ex. 1 => Medicament | 2 => Consommable

            error_message: '',
            is_error: false
            
        }
    },
    computed: {
        type_attributs() {
            return this.$store.getters['attributs']
        },
        type() {
            return this.$store.getters['type']
        },
    },
    mounted () {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

        this.getListeAttributTypeArticle()

        this.$store.dispatch("getTypeAttribut");
    },
    methods: {
        getListeAttributTypeArticle() {
            this.$store.dispatch("getType", this.$route.params.id).then(() => {
                console.log(this.type);
            })
        },
 
        changeType(event) {

            if(event.target.value == 6 || event.target.value == 7) {
                this.$set(this.attribut, 'occurence', [])
            } else {
                this.$delete(this.attribut, 'occurence')
            }
        },

        enterClicked(){
            if(this.val_occurence == "") {
                return
            }
            const new_occurence = {
                libelle: this.val_occurence
            }
            this.attribut.occurence.push(new_occurence)
            this.occurences_to_add.push(this.val_occurence);
            this.val_occurence = ''
        }, 

        setAttribut(data) {
            this.type_article_id = data.type_article_id

            if( data.type_attribut_id == 6 || data.type_attribut_id == 7) {

                this.attribut.occurence= []

                console.log(data);
                data.occurence.forEach(element => {
                    const occurence = {
                        occurence_id: element.id,
                        libelle: element.libelle
                    }
                    this.attribut.occurence.push(occurence)
                });

                this.$set(this.attribut, 'id', data.id)
                this.$set(this.attribut, 'libelle', data.libelle)
                this.$set(this.attribut, 'type_attribut_id', data.type_attribut_id)
                this.$set(this.attribut, 'occurence', this.attribut.occurence)
                this.$set(this.attribut, 'type', data.type)

            } else {

                this.$delete(this.attribut, 'occurence')
                this.$set(this.attribut, 'id', data.id)
                this.$set(this.attribut, 'libelle', data.libelle)
                this.$set(this.attribut, 'type_attribut_id', data.type_attribut_id)
                this.$set(this.attribut, 'type', data.type)
            }

        },

        deleteAttribut() {
            this.$store.dispatch("deleteTypeArticleAttribut", this.attribut.id);
            this.$refs.close_delete.click()
        },

        deleteOccurence(occurence, index) {
            this.attribut.occurence.splice(index, 1)

            if (occurence?.occurence_id) {
                this.occurences_to_delete.push(occurence)
            } else {
                this.occurences_to_add = this.occurences_to_add.filter(occ => occ !== occurence.libelle)
            }
        },

        async updateAttribut() {
            const isValid = await this.$refs.attr_form.validate();

            if (!isValid) {
                return;
            }

            console.log(this.occurences_to_delete);

            this.save_loading = true
            const data = {
                type_article_id: this.type_article_id,
                libelle:  this.attribut.libelle,
                attribut_article_id: this.attribut.id,
                type_attribut_id:  this.attribut.type_attribut_id,
                occurences_tobe_deleted: this.occurences_to_delete,
                occurences_tobe_added: this.occurences_to_add
            }   

            await this.$store.dispatch("editTypeArticleAttribut", data).then((response) => {
                console.log(response);
                if (response.success) {
                    this.occurences_to_add = []
                    this.occurences_to_delete = []

                    console.log("refresh");

                    this.getListeAttributTypeArticle()
                    this.$refs.update_occ.click()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.save_loading=false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

        /**
         * Close Modal
         * @param {*} selector 
        */
        closeModal(selector) 
        {
            closeModal.closeModal(selector);
        }

    }
}


